<template>
  <b-modal
    centered
    id="select-lead-dialog"
    modal-class="overflow-hidden"
    size="lg"
    static
    hide-footer
  >
    <template #modal-header="{ close }">
      <h5 class="modal-title">Bảng chọn Lead</h5>
      <button type="button" class="close" @click="close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Tên MC/Email/Số điện thoại</label>
      <div class="col-sm-7">
        <input
          type="text"
          v-model.trim="search.textSearch"
          @keyup.enter="getListLead()"
          class="form-control"
        />
      </div>
      <button class="btn btn-success btn-primary" @click="getListLead()">Tìm kiếm</button>
    </div>
    <b-table
      ref="select-lead-table"
      style="max-height: 55vh"
      :fields="fields"
      :busy.sync="loading"
      sticky-header
      responsive
      hover
      bordered
      selectable
      select-mode="single"
      :items="dataListMC"
      @row-selected="onRowSelected"
    >
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template #table-busy>
        <div class="my-2 text-center">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template #cell(Lead)="data">
        <b>Người đại diện:</b> {{ data.item.customerName }}<br />
        <b>MC:</b> {{ data.item.merchantName }}<br />
        <b>Email:</b> {{ data.item.email }} <br />
        <!-- <b>SĐT:</b> {{ data.item.mobile }} -->
      </template>
      <template #cell(region)="data">
        {{ data.item.regionId | transfromData(dataConfigRegion) }} -
        {{ data.item.city }}
      </template>
    </b-table>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </b-modal>
</template>

<script>
  import { LeadsService } from '@/services/lead.service'
  import { StaffService } from '@/services/staff.service'
  export default {
    data() {
      return {
        fields: [
          {
            key: 'selected',
            label: '',
            tdClass: 'text-center',
            thStyle: 'min-width: 30px',
          },
          'Lead',
          { key: 'region', label: 'Vùng kinh doanh' },
        ],
        dataListMC: [],
        search: {
          limit: 50,
          page: 1,
        },
        loading: false,
        total: 0,
        disabled: true,
        selectedMC: [],
        dataConfigRegion: [],
        selected: null,
      }
    },
    props: {
      listLead: {
        type: Boolean,
        default: false,
      },
    },

    watch: {
      'search.page': function () {
        this.getListLead()
      },
    },

    created() {
      this.getRegions()
      this.getListLead()
    },

    methods: {
      onRowSelected(items) {
        this.disabled = !(items.length > 0)
        this.selected = items.length > 0 ? items[0] : null
        this.$emit('selectLead', this.selected)
        this.$bvModal.hide('select-lead-dialog')
      },
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => ({
            id: e.id,
            text: e.name,
          }))
        }
      },
      async getListLead() {
        try {
          this.loading = true
          if (this.search.textSearch === '') delete this.search.textSearch
          let response
          if (this.listLead === true) {
            response = await LeadsService.getListLeads(this.search)
          } else response = await LeadsService.getListOwner(this.search)
          if (response.code === 1000) {
            this.dataListMC = response.data
            this.total = response.meta?.pagination?.total ?? 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped></style>
